export default Object.freeze(
  {
    DAYS: 'days',
    WEEKS: 'weeks',
    MONTHS: 'months',
  }
)